import { useEffect, useState } from 'react';
import terraHelper from 'helpers/terra';
import { ScreenConfig } from '@terra-js/shop-front-kit';

export const useTerraScreenConfig = () => {
  const [screenConfig, setScreenConfig] = useState<ScreenConfig | undefined>();

  useEffect(() => {
    (async () => {
      const config = await terraHelper.getScreenConfig();
      setScreenConfig(config);
    })();
  }, []);

  return screenConfig;
};
